var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"error"},[_c('img',{attrs:{"src":require("@/assets/img/sorry404.svg"),"alt":"404页面"}}),_vm._v(" "),_c('div',{staticClass:"back"},[_c('p',[_vm._v("倒数"),_c('i',[_vm._v(_vm._s(_vm.time)+"s")]),_vm._v("自动回到首页")]),_vm._v(" "),_c('router-link',{attrs:{"tag":"button","to":"/"}},[_vm._v("马上回到首页")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1ce1cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Error/error.vue
// module id = RSFA
// module chunks = 1